import create from 'zustand';
import { FiltersUIState } from '../models';

export const useFilterUIState = create<FiltersUIState>((set) => ({
    filtersCount: 0,
    // isSortDrawerOpen: false,
    // isFilterPanelOpen: false,
    // isFilterDrawerOpen: false,
    // isMobileFilterDrawerOpen: false,
    iconicFilterButtonsIsOutOfView: false,
    maxPrice: null,
    minPrice: null,
    selectedFilterGroup: null,
    preSelectedIndexKey: null,
    setMaxPrice: (maxPrice: number | null) => {
        set(() => ({
            maxPrice,
        }));
    },
    setMinPrice: (minPrice: number | null) => {
        set(() => ({
            minPrice,
        }));
    },
    setFiltersCount: (filtersCount: number) => {
        set(() => ({
            filtersCount,
        }));
    },
    // setIsSortDrawerOpen: (isSortDrawerOpen: boolean) => {
    //     set(() => ({
    //         isSortDrawerOpen,
    //     }));
    // },
    // setIsFilterPanelOpen: (isFilterPanelOpen: boolean) => {
    //     set(() => ({
    //         isFilterPanelOpen,
    //     }));
    // },
    // setIsFilterDrawerOpen: (isFilterDrawerOpen: boolean) => {
    //     set(() => ({
    //         isFilterDrawerOpen,
    //     }));
    // },
    // setIsMobileFilterDrawerOpen: (isMobileFilterDrawerOpen: boolean) => {
    //     set(() => ({
    //         isMobileFilterDrawerOpen,
    //     }));
    // },
    setIconicFilterButtonsIsOutOfView: (iconicFilterButtonsIsOutOfView: boolean) => {
        set(() => ({
            iconicFilterButtonsIsOutOfView,
        }));
    },
    setSelectedFilterGroup: (selectedFilterGroup: string | null) => {
        set(() => ({
            selectedFilterGroup,
        }));
    },
    setPreSelectedIndexKey: (preSelectedIndexKey: string | null) => {
        set(() => ({
            preSelectedIndexKey,
        }));
    },
}));
